import { createReducer } from '@reduxjs/toolkit';
import {
    dEpsCheckedAllTerminalsItemAC,
    dEpsCheckedTerminalsItemAC,
    dEpsClearStateAC,
    dEpsSetDataAC, dEpsSetDetailsEPSItemAC, dEpsSetDetailsTerminalsItemAC,
    dEpsSetEpsListAC, dEpsSetPosSettingsListAC,
} from 'model/dashboardEPS/dEpsActionCreators';
import { logoutAC } from 'model/system/systemActionCreators';

type typeStoreItem = {
    address: string,
    deleted: boolean,
    description: string,
    email: string,
    id: string,
    industry?: {
        id: string,
        name: string
    },
    manager: string,
    managerPhoneNumber: string,
    name: string,
    phoneNumber: string
}

export type typeTerminalItem = {
    dateCreated: string,
    dateEdited: string,
    fiscalCardId: string,
    id: string,
    posHardwareModel: string,
    posHardwareSerialNumber: string,
    posNumber: number,
    store?: typeStoreItem,
    blocked: boolean
}
type typeEpsPaymentType = 'CREDIT' | 'PAYMENT'

type typePaymentSystem = {
    'getObjectsByMerchantInnUrl': string,
    'id': string,
    'name': string,
    'presaleCallbackUrl': string,
    'types': typeEpsPaymentType[]
    "active": boolean
}

export type typeMerchantPaymentSystem = {
    terminalsIds?: string[]
    'id': string,
    'paymentSystem': typePaymentSystem,
    "active": boolean
}

export type typePaymentSystemObject = {
    'externalId': string,
    'id': string,
    'paymentSystem': typeMerchantPaymentSystem
}

export type typePosSettingsEpsItem = {
    'id': string,
    'paymentSystemObjects': typePaymentSystemObject [],
    'posId': string
}


export type typeEpsTableDataItem = {
    terminalData: typeTerminalItem
    epsList: { epsId: string, active: boolean }[]
    posSettings: typePosSettingsEpsItem
    checked: boolean
}

export type typePaymentSystemOffice = {
    'address': string ,
    'id': string,
    'name': string,
}

export type typeEpsState = {
    data: typeEpsTableDataItem[],
    connectedEps: typeMerchantPaymentSystem[],
    posSettingsList: typePosSettingsEpsItem[],
    detailsTerminal: typeEpsTableDataItem | null
    detailsEps: typeMerchantPaymentSystem | null
}

export const initialState: typeEpsState = {
    data: [],
    connectedEps: [],
    posSettingsList: [],
    detailsTerminal: null,
    detailsEps: null
}

export const DEPSReducer = createReducer(
    initialState, builder => {
        builder
            // Reducer of set data
            .addCase(dEpsSetDataAC, (state, action) => {
                state.data = action.payload.dataList
            })
            // Reducer of set connected eps
            .addCase(dEpsSetEpsListAC, (state, action) => {
                state.connectedEps = action.payload.dataList
            })
            // Reducer of set available eps
            .addCase(dEpsSetPosSettingsListAC, (state, action) => {
                state.posSettingsList = action.payload.dataList
            })
            // Reducer of set checked item
            .addCase(dEpsCheckedTerminalsItemAC, (state, action) => {
                state.data = state.data.map(item => {
                    if (item.terminalData.id === action.payload) {
                        const newItem = item
                        newItem.checked = !item.checked
                        return newItem
                    } else {
                        return item
                    }
                })
            })

            // Reducer of set checked all items
            .addCase(dEpsCheckedAllTerminalsItemAC, (state, action) => {
                state.data = state.data.map(item => {
                    const newItem = item
                    newItem.checked = action.payload
                    return newItem
                })
            })

            // Reducer of set detailsData terminal item
            .addCase(dEpsSetDetailsTerminalsItemAC, (state, action)=>{
                state.detailsTerminal = action.payload
            })
            // Reducer of set detailsData eps item
            .addCase(dEpsSetDetailsEPSItemAC, (state, action)=>{
                state.detailsEps = action.payload
            })
            // Reducer of clear state
            .addCase(dEpsClearStateAC, (state) => {
                state.data = initialState.data
                state.connectedEps = initialState.connectedEps
                state.detailsTerminal = initialState.detailsTerminal
                state.detailsEps=initialState.detailsEps
            })

            // Reducer of clear state
            .addCase(logoutAC, (state) => {
                state.data = initialState.data
                state.connectedEps = initialState.connectedEps
                state.detailsTerminal = initialState.detailsTerminal
                state.detailsEps=initialState.detailsEps
            })
    }
)
